import LoadingSpinner from "./LoadingSpinner";

export default function PageLoading({ label = "Carregando..." }) {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingSpinner size="lg" label={label} />
    </div>
  );
}
